var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view',{attrs:{"user":_vm.user}}),(!_vm.fullscreen)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }